// extracted by mini-css-extract-plugin
export default {"description":"ForMilitary_description__2HuVQ","container":"ForMilitary_container__l7kUZ"};